<template>
  <div class='indexbox'>
    <div class="tablebox">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="val.shop_name" :name="val.id_tostrign" v-for="val in tablist" :key="val.shop_name">
        </el-tab-pane>
      </el-tabs>
      <div class="draggable" v-loading='loading'>
        <el-table :data="tableData" stripe border>
          <el-table-column prop="Description" :label="$t('lg.DEAR承运人')" align="left" min-width='200' fixed='left' show-overflow-tooltip />
          <el-table-column prop="waybillPlatform_name" :label="$t('lg.物流平台')" align="left" min-width='200' show-overflow-tooltip />
          <el-table-column prop="waybillPlatformType_name" :label="$t('lg.物流平台类型')" align="left" min-width='200' show-overflow-tooltip />
          <el-table-column prop="logistics" :label="$t('lg.所属物流名称')" align="left" min-width='200' show-overflow-tooltip />
          <el-table-column prop="is_default" align="left" min-width='200' show-overflow-tooltip>
            <template slot="header">
              {{$t('lg.是否默认')}}
              <el-tooltip :content="$t('lg.是否默认tip')" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template scope="scope">
              <el-checkbox size='medium' v-model="scope.row.is_default" :false-label='0' :true-label='1' :disabled='scope.row.is_default==1?true:false' @change="setDefault(scope.row)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('lg.状态')" align="left" min-width='200' show-overflow-tooltip fixed='right'>
            <template scope="scope">
              <el-button slot="reference" type="primary" size="small" v-if="scope.row.status==0" @click="lookdata(scope.row)">{{$t('lg.启用')}}</el-button>
              <el-popconfirm :title="$t('lg.确定要禁用吗')" @confirm='operation(scope.row)'>
                <el-button slot="reference" type="text" size="small" v-if="scope.row.status==1">{{$t('lg.已启用')}}</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change='pagechage' @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" background layout="total,sizes,prev, pager, next" v-show="total>0" :current-page.sync="page" :page-size="page_size" :total="total" />
    </div>
    <el-dialog :title="$t('lg.启用')" :visible.sync="show" width="30%">
      <el-form ref="form" :model="form" :rules="rules" class="formbox">
        <el-form-item prop="waybillPlatform">
          <span class="form_tit">{{$t('lg.物流平台')}}*</span>
          <el-select v-model="form.waybillPlatform" filterable :placeholder="$t('lg.请选择')">
            <el-option v-for="item in waybillPlatformlist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="waybillPlatformType">
          <span class="form_tit">{{$t('lg.物流平台类型')}}*</span>
          <el-select v-model="form.waybillPlatformType" filterable :placeholder="$t('lg.请选择')">
            <el-option v-for="item in waybillPlatformTypelist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="logisticsId">
          <span class="form_tit">{{$t('lg.所属物流')}}*</span>
          <el-select v-model="form.logisticsId" filterable :placeholder="$t('lg.请选择')">
            <el-option v-for="item in logisticsIdlist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="btnbox">
          <el-button type="primary" @click.native.prevent="onSubmit" :loading='btn_loading'>{{$t('lg.保存')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id']),
    },
    data() {
      return {
        activeName: '',
        tablist: [],
        total: 0,
        page: 1,
        page_size: 10,
        tableData: [],
        loading: false,
        // 开启
        show: false,
        btn_loading: false,
        form: {
          id: '',
          waybillPlatform: '',
          waybillPlatformType: '',
          logisticsId: '',
        },
        rules: {
          waybillPlatform: [
            {
              required: true, trigger: "blur", message: this.$t('lg.请选择')
            }
          ],
          waybillPlatformType: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
          logisticsId: [
            { required: true, trigger: "blur", message: this.$t('lg.请选择') }
          ],
        },
        waybillPlatformlist: [],
        waybillPlatformTypelist: [],
        logisticsIdlist: [],

      };
    },
    methods: {
      gettablist() {
        this.$post({
          url: "/app/member_shop/shopList",
          data: {
            page: 1,
            page_size: 1000,
            api_id: this.api_id,
          },
          success: (res) => {
            res.data.data.forEach(item => {
              item.id_tostrign = item.id.toString()
            });
            this.tablist = res.data.data
            if (this.tablist.length > 0) {
              if (sessionStorage.getItem("carrier_activeName")) {
                this.activeName = sessionStorage.getItem("carrier_activeName")
              } else {
                this.activeName = res.data.data[0].id_tostrign
              }
            } else {
              sessionStorage.removeItem('carrier_activeName')
            }
            this.$nextTick(() => {
              this.getlist()
            })
          },
          tip: () => {
          },
        })
      },
      handleClick(tab) {
        this.activeName = tab.name
        sessionStorage.setItem("carrier_activeName", tab.name)
        this.pagechage(1)
      },
      getlist() {
        this.loading = true
        this.$post({
          url: "/app/carrier/pageList",
          data: {
            page: this.page,
            page_size: this.page_size,
            shop_id: this.activeName
          },
          success: (res) => {
            if (res.data.total) {
              this.tableData = res.data.data
              this.total = res.data.total
              this.page_size = Number(res.data.per_page)
              this.page = res.data.current_page
            }
            setTimeout(() => {
              this.loading = false
            }, 200);
          },
          tip: () => {
            this.loading = false
          },
        })
      },
      pagechage(page) {
        this.page = page
        this.tableData = []
        this.getlist()
      },
      handleSizeChange(size) {
        this.page_size = size
        this.tableData = []
        this.getlist()
      },
      // 开启数据
      lookdata(row) {
        this.loading = true
        this.form = {
          id: row.id,
          waybillPlatform: '',
          waybillPlatformType: '',
          logisticsId: '',
        }

        this.$post({
          url: "/app/carrier/getWaybillPlatform",
          success: (res) => {
            this.waybillPlatformlist = res.data
          },
          tip: () => {
          },
        })
        this.$post({
          url: "/app/carrier/getWaybillPlatformType",
          success: (res) => {
            this.waybillPlatformTypelist = res.data
          },
          tip: () => {
          },
        })
        this.$post({
          url: "/app/carrier/getLogistics",
          success: (res) => {
            this.logisticsIdlist = res.data
          },
          tip: () => {
          },
        })
        setTimeout(() => {
          this.loading = false
          this.show = true
        }, 500);

      },
      // 开启
      onSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.btn_loading = true
            this.$post({
              url: "/app/carrier/open",
              data: this.form,
              success: res => {
                this.$message({
                  message: res.msg,
                  type: 'success'
                });
                setTimeout(() => {
                  this.show = false
                  this.pagechage(this.page)
                  this.btn_loading = false
                }, 1500);
              },
              tip: () => {
                setTimeout(() => {
                  this.btn_loading = false
                }, 1500);
              },
            })
          }
        });
      },
      //关闭物流
      operation(row) {
        this.$post({
          url: "/app/carrier/close",
          data: {
            id: row.id
          },
          success: res => {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.pagechage(this.page)
            }, 1500);
          },
          tip: () => {
          },
        })
      },
      // 默认
      setDefault(row) {
        this.$confirm(`${this.$t('lg.确定要设置为默认吗')}?`, this.$t('lg.提示'), {
          confirmButtonText: this.$t('lg.确定'),
          cancelButtonText: this.$t('lg.取消'),
          type: 'warning'
        }).then(() => {
          this.$post({
            url: "/app/carrier/setDefault",
            data: {
              id: row.id
            },
            success: res => {
              this.$message({
                message: res.msg,
                type: 'success'
              });
              setTimeout(() => {
                this.pagechage(this.page)
              }, 1200);
            },
            tip: () => {
              row.is_default = !row.is_default
            },
          })
        }).catch(() => {
          row.is_default == 1 ? row.is_default = 0 : row.is_default = 1
        });
      },
    },
    created() {
      this.gettablist()
    },
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .tablebox {
      width: 100%;
      padding: 20px;
    }
    .formbox {
      /deep/.el-form-item {
        margin-bottom: 30px !important;
        .el-form-item__content {
          width: 100%;
          .el-select {
            width: 100%;
          }
          .el-button {
            width: 100%;
            height: 48px;
            background: $color;
            border-radius: 5px;
            border-color: $color;
          }
        }
      }
    }
  }
</style>